import React from 'react'
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  FormHelperText,
} from '@mui/material'
import styles from './SelectMultipleDropdownNew.module.scss'

export interface MultiSelectOption {
  value: string
  label: string
}

export interface MultiSelectProps {
  value: string[]
  onChange: (value: string[]) => void
  options: MultiSelectOption[]
  label?: string
  icon?: React.ReactNode
  error?: string
  required?: boolean
}

export const SelectMultipleDropdownNew: React.FC<MultiSelectProps> = ({
  value,
  onChange,
  options,
  label,
  icon,
  error,
  required,
}) => {
  return (
    <FormControl fullWidth error={!!error}>
      {label && (
        <InputLabel
          shrink={value.length > 0}
          className={styles.selectMultiple__label}
        >
          {label}
          {required && ' *'}
        </InputLabel>
      )}

      {icon && <div className={styles.selectMultiple__icon}>{icon}</div>}

      <Select
        multiple
        value={value}
        className={styles.selectMultiple}
        onChange={e => onChange(e.target.value as string[])}
        renderValue={selected => (
          <div className={styles.selectMultiple__chipList}>
            {selected.map(val => (
              <Chip
                key={val}
                label={options.find(o => o.value === val)?.label}
              />
            ))}
          </div>
        )}
      >
        {options.map(opt => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>

      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}
